// 9fbef606107a605d69c0edbcd8029e5d

const MENU_ITEM_TYPES = {
  HEADLINE: "headline",
  BACK_BTN: "backBtn",
  LIST: "list",
};

export default MENU_ITEM_TYPES;
